import React from "react";
import PropTypes from "prop-types";
import "./rctiDesign.css";

export const agreementReference = (id) =>
  `AGR-${String(id || "")
    .slice(-8)
    .toUpperCase()}`;
export const agreementLabel = (status) =>
  ({
    proposed: "Awaiting signature",
    pending: "Awaiting signature",
    active: "Active",
    suspended: "Suspended",
    ended: "Ended",
    rejected: "Rejected",
  }[status] || status);
export function RctiSteps({
  steps,
  current = 0,
  enabledSteps = [],
  onStepClick,
}) {
  return (
    <ol className="rcti-journey" aria-label="Progress">
      {steps.map((step, index) => (
        <li
          key={step[0]}
          className={`${index === current ? "is-current" : ""}${
            index < current ? " is-complete" : ""
          }${enabledSteps.includes(index) ? " is-clickable" : ""}`}
          aria-current={index === current ? "step" : undefined}
        >
          <button
            type="button"
            className="rcti-journey-step"
            disabled={!enabledSteps.includes(index)}
            onClick={() => onStepClick?.(index)}
            aria-label={`${step[0]}${step[1] ? `: ${step[1]}` : ""}`}
          >
            <span>{index < current ? "✓" : index + 1}</span>
            <div>
              <strong>{step[0]}</strong>
              <small>{step[1]}</small>
            </div>
          </button>
        </li>
      ))}
    </ol>
  );
}
RctiSteps.propTypes = {
  steps: PropTypes.array.isRequired,
  current: PropTypes.number,
  enabledSteps: PropTypes.arrayOf(PropTypes.number),
  onStepClick: PropTypes.func,
};
export const rctiSteps = [
  ["Prepare", "Supplier, dates & items"],
  ["Eligibility review", "Required checks"],
  ["Preview & issue", "Document & supplier email"],
];
